export enum DrawerViewType {
  Hub = 'hub',
  Surgeon = 'surgeon',
}
